<template>
  <l-layout :layout="['xs12']">
    <v-card>
      <l-data-table
        :headers="header"
        ref="labelList"
        :get-data-func="(labelType==='sys')?getSysLabelList:getBizLabelList"
        clickable
        @click:row="getDetails($event.item)"
      >
        <template slot="title">
          <span class="pl-2 pr-4">消息标签列表</span>
          <v-radio-group mandatory row v-model="labelType">
            <v-radio :value="'sys'" label="系统标签"></v-radio>
            <v-radio :value="'biz'" label="自定义标签"></v-radio>
          </v-radio-group>
        </template>
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center">
            <v-tooltip left>
              <v-btn @click="(labelType==='sys')?deleteSysLabelConfirm(item):deleteBizLabelConfirm(item)" slot="activator" icon>
                <v-icon small>$vuetify.icons.delete</v-icon>
              </v-btn>
              <span>删除标签</span>
            </v-tooltip>
          </td>
        </template>
      </l-data-table>
      <l-fixed-btn
        @click="addLabel"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </v-card>
  </l-layout>
</template>

<script>
export default {
  name: 'MessageLabel',
  data () {
    return {
      labelType: 'sys',
      header: [
        {text: '标签名称', value: 'name', align: 'left', sortable: false},
        {text: '创建者', value: 'creator', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', sortable: true, f: (v) => (this.$L.time.stringify(v))},
        {text: '', value: '', align: 'left', sortable: false}
      ]
    }
  },
  computed: {
    refresh () {
      //console.log(this.$store.state.message.classRefresh)
      return this.$store.state.message.labelRefresh
    }
  },
  activated () {
    if (this.refresh) {
      this.$refs.labelList.refresh()
      this.$store.commit('message/setLabelRefresh', false)
    }
  },
  methods: {
    async getSysLabelList ({pagination, sortStack, filterItems, search}) {
      let url = '/messageApi/admin/getMsgLabelSys'
      let {items, amount} = await this.$store.dispatch('message/getList', {pagination, sortStack, filterItems, search: {key: 'name', value: search}, url: url})
      return {items, amount}
    },
    async getBizLabelList ({pagination, sortStack, filterItems, search}) {
      let url = '/messageApi/admin/getMsgLabelBiz'
      let {items, amount} = await this.$store.dispatch('message/getList', {pagination, sortStack, filterItems, search: {key: 'name', value: search}, url: url})
      return {items, amount}
    },
    addLabel () {
      this.$router.push({name: 'newMessageLabel'})
    },
    async deleteSysLabelConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该标签？',
        text: '标签名称:' + item.name
      })
      if (res) {
        try {
          await this.deleteSysLabel(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteSysLabel (item) {
      let url = '/messageApi/admin/deleteMsgLabelSys'
      let ids = []
      ids.push(item.id)
      let params = {'idList': ids}
      let res = await this.$store.dispatch('message/deleteActions', {params: params, url: url})
      if (res.data.code + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.labelList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
      }
    },
    async deleteBizLabelConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该标签？',
        text: '标签名称:' + item.name
      })
      if (res) {
        try {
          await this.deleteBizLabel(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteBizLabel (item) {
      let url = '/messageApi/admin/deleteMsgLabelBiz'
      let ids = []
      ids.push(item.id)
      let params = {'idList': ids}
      let res = await this.$store.dispatch('message/deleteActions', {params: params, url: url})
      if (res.data.code + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.labelList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
      }
    },
    getDetails (item) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({name: 'labelDetailBox', query: {id: item.id, type: this.labelType}})
      }
    }
  }
}
</script>

<style scoped>

</style>
